import React from "react";
import { Link } from "react-router-dom";

const FooterOneAr = () => {
  return (
    <>
      <div className="footer__area section-padding">
        <div className="container">
          <div className="row align-items-center">
            <div className="copyright__area copyright__area-one">
              <div className="container">
                <div className="row align-items-center copyright__area-border">
                  <div className="col-xl-12" style={{ paddingTop: "1rem" }}>
                    <div className="copyright__area-left copyright__area-one-left">
                      <p>
                        Copyright © 2025 by{" "}
                        <a
                          href="https://www.neoneg.com/"
                          target="_blank"
                          style={{ color: "white" }}
                        >
                          {" "}
                          NEON
                        </a>{" "}
                        <a
                          href="https://wa.me/+2001113588988"
                          target="_blank"
                          style={{ color: "white" }}
                        >
                          <i className="fab fa-whatsapp"></i>
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FooterOneAr;
